import {EventType} from 'services/analytics';

interface Settings<TKind extends EventType, TPayload> {
  name: AnalyticsEventName;
  converter?: TKind extends EventType.Plain ? never : ParametersConverter<TPayload>;
}

export function buildEventCreator<TKind extends EventType, TPayload = AnalyticsPayload>({
  name,
  converter,
}: Settings<TKind, TPayload>): EventFactory<TPayload> {
  return function thirdPartyEventFactory(payload?: TPayload): ThirdPartyEvent {
    const params = payload && converter && converter(payload);
    return {event: name, params};
  };
}
